import * as React from 'react';
import { useState } from 'react';
import './edit.scss';
import { Radio } from 'antd';

import { Page } from '../../../../../components/page/page';
import { EditUserForm } from './sections/form';
import { EditUserBalance } from './sections/balance';

export const EditUser: React.FC = () => {
    const [stages, setStages] = useState<'form' | 'balance'>('form');

    return (
        <Page title="تغییر اطلاعات کاربر" className="pmx-dashboard-users-edit">
            <div className="button-group-container">
                <Radio.Group size="large" value={stages} onChange={(e) => setStages(e.target.value)}>
                    <Radio.Button value="form">ویرایش</Radio.Button>
                    <Radio.Button value="balance">موجودی</Radio.Button>
                </Radio.Group>
            </div>
            {stages === 'form' && <EditUserForm />}
            {stages === 'balance' && <EditUserBalance />}
        </Page>
    );
};
